<template>
    <div v-show="pageShow" :class="{ 'page-locked': showMask }">
        <div :class="['bg', { 'bg-hidden': showActivity }]" class="re_sizing re_relative re_flex_center" id="codeShare">
            <img class="bgImg" src="../../../assets/register/registerCode.png" alt="">
            <div class="modal re_relative re_flex_center">
                <img v-if="info.inviteQrcode" class="code re_relative" :src="info.inviteQrcode1 || info.inviteQrcode" alt="">
                <img v-if="info.photo" :src="info.photo1 || info.photo" alt="" class="codeImg re_absolute">
            </div>
            
            <div v-if="!showActivity" class="mask_1 mask-default" ref="mask" v-longpress="handleLongPress"></div>
        </div>
        <div v-if="showActivity" class="bg_1 re_sizing re_relative" ref="bg_1">
            <div class="lineNo"></div>
            <van-swipe vertical class="notice-swipe" :autoplay="3000" :touchable="false" :show-indicators="false">
                <van-swipe-item class="item-volume" v-for="(value, index) in listRandom" :key="index">
                    <img src="../../../assets/register/iconTips.png" alt="">
                    {{ value.scrollText }}
                </van-swipe-item>
            </van-swipe>
            <img class="bgImg" src="../../../assets/register/invite_code.png" alt="">
            <div class="modal re_relative re_flex_center">
                <img class="code re_relative" :src="info.inviteQrcode" alt="">
                <img :src="info.photo" alt="" class="codeImg re_absolute">
            </div>
            <div class="card_list">
                <div class="card_title">
                    <div @click="changeIndex(1)" :class="['title-item', { 'active': titleIndex === 1 }]">
                        收益排行榜
                        <div class="line"></div>
                    </div>
                    <div @click="changeIndex(2)" :class="['title-item', { 'active': titleIndex === 2 }]">
                        我的收益
                        <div class="line"></div>
                    </div>
                </div>
                <div class="scroll_content re_margin_top_8">
                    <van-list offset="30" :immediate-check="false" v-model:loading="loading" :finished="finished"
                        @load="onLoad" finished-text="没有更多了">
                        <van-cell class="cellItem" v-for="(item, index) in listData" :key="index">
                            <template #default>
                                <div v-if="titleIndex === 2" class="item1 re_flex_between re_font_bold re_margin_top_24">
                                    <div class="item_left">
                                        <div class="re_font_16 re_color_normal">{{ item.label }}</div>
                                        <div class="re_font_14 re_color_second re_margin_top_4">来源用户：{{
                                            item.registerNickName }}
                                        </div>
                                        <div class="re_font_12 re_color_light re_margin_top_4">{{ item.createTime }}</div>
                                    </div>
                                    <div class="item_right color_red">
                                        <div>
                                            <span class="re_font_14">￥</span>
                                            <span class="re_font_20">{{ item.userAmount }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="item">
                                    <div class="item_l">
                                        <div class="ranking">
                                            <img v-if="item.rankNo === 1" src="../../../assets/register/one.png" alt="">
                                            <img v-else-if="item.rankNo === 2" src="../../../assets/register/two.png" alt="">
                                            <img v-else-if="item.rankNo === 3" src="../../../assets/register/three.png"
                                                alt="">
                                            <text v-else>{{ item.rankNo }}</text>
                                        </div>
                                        <div class="avatar">
                                            <img :src="item.photo" alt="">
                                        </div>
                                        <div class="name">{{ item.nickName }}</div>
                                    </div>
                                    <div class="item_r">{{ item.amount }}元</div>
                                </div>
                            </template>
                        </van-cell>
                    </van-list>
                </div>
            </div>
            <div style="height: 1.875rem;"></div>
            
            <div class="mask_1" ref="mask" v-longpress="handleLongPress"></div>
        </div>
        <div v-if="showMask" class="modal-content re_absolute" @click.stop @touchmove.prevent @wheel.prevent>
            <img src="https://tp.kaishuihu.com/static/yindao.png" alt="" class="img1">
            <img src="https://tp.kaishuihu.com/static/yaoqing_wenan.png" alt="" class="re_margin_top_24 img2">
            <img @click="showMask = false" src="https://tp.kaishuihu.com/static/anniu.png" alt=""
                class="re_margin_top_24 img3">
        </div>
    </div>
</template>

<script setup>
// import { useRouter } from 'vue-router'
import { ref, onMounted } from 'vue';
// const router = useRouter()
import { briefInfo, getInfo2025, inviteTopList, recordList } from './api.js'
// import domtoimage from 'dom-to-image';
import html2canvasMin from '@/utils/html2canvas.min.js';
const showMask = ref(false)
const pageShow = ref(false)

const titleIndex = ref(1)
const pages = ref(1)
const pageSize = ref(15)

const loading = ref(false); // 加载状态
const finished = ref(false);
const listData = ref([])
const changeIndex = (index) => {
    titleIndex.value = index
    finished.value = false
    if (index == 1) {
        listData.value = []
        getList()
    } else {
        pages.value = 1
        listData.value = []
        recordListFn()
    }
}
const bg_1 = ref('')
const mask = ref('')
const recordListFn = () => {
    loading.value = true;
    console.log({ pageNum: pages.value, pageSize: pageSize.value })
    recordList({ pageNum: pages.value, pageSize: pageSize.value }).then(res => {
        loading.value = false;
        listData.value = [...listData.value, ...res.rows]
        if (res.rows.length < pageSize.value ) {
            finished.value = true;
        }
        console.log(listData.value)
    })
}
const onLoad = (page) => {
    if (titleIndex.value == 1) return loading.value = false
    if (page == 1) {
        pages.value == 1
    } else {
        pages.value += 1;
    }
    recordListFn()
}
onMounted(() => {
    activityFn()
    getInfo()
})
const handleLongPress = async () => {
    // alert('长按事件触发！');
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    const node = document.getElementById('codeShare')

    const canvas = await html2canvasMin(node, { useCORS: true, scale: 2 })
    const imgUrl = canvas.toDataURL("image/png");
    console.log(imgUrl)
    // return
    // domtoimage.toPng(node).then(dataUrl => {
    console.log(imgUrl.length)
    // alert(dataUrl.length)
    if (isAndroid) {
        appJsImp.shareDownImg(imgUrl)
    }
    if (isiOS) {
        sendBase64ImageToiOS(imgUrl)
    }
    // })
}
// 分片传输 base64 图片到 iOS
function sendBase64ImageToiOS(base64String) {
    // 移除 base64 前缀（如果存在）
    const pureBase64 = base64String.replace(/^data:image\/\w+;base64,/, '');
    console.log('开始传输图片' + pureBase64.length)
    const chunkSize = 16 * 1024; // 50KB 每个分片
    const totalChunks = Math.ceil(pureBase64.length / chunkSize);

    console.log(`开始传输图片，总分片数: ${totalChunks}, 总长度: ${pureBase64.length}`);
    // 先发送分片信息
    // 发送初始化信息
    window.webkit.messageHandlers.AppModel.postMessage({
        'type': 'init',
        'totalChunks': totalChunks,
        'totalLength': pureBase64.length
    });

    // 分片发送数据
    for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, pureBase64.length);
        const chunk = pureBase64.substring(start, end);

        setTimeout(() => {
            window.webkit.messageHandlers.AppModel.postMessage({
                'type': 'chunk',
                'index': i,
                'data': chunk
            });
        }, i * 10); // 添加微小延迟避免阻塞
    }
    console.log('wancheng')
    // 发送完成信号
    setTimeout(() => {
        window.webkit.messageHandlers.AppModel.postMessage({
            'type': 'complete'
        });
    }, totalChunks * 10 + 100);
}

const list = ref([])
const listRandom = ref([])
const randomSortArray = (arr) => {
    var stack = [];
    while (arr.length) {
        var index = parseInt(Math.random() * arr.length);
        stack.push(arr[index]);
        arr.splice(index, 1);
    }
    return stack;
}
function maskNicknameAdvanced(nickname) {
    if (!nickname) return nickname;
    
    // 使用数组方式处理，更好地支持Unicode字符（如表情符号）
    const chars = [...nickname];
    
    if (chars.length <= 1) {
        return nickname;
    }
    
    if (chars.length === 2) {
        return chars[0] + '***';
    }
    
    const firstChar = chars[0];
    const lastChar = chars[chars.length - 1];
    
    return firstChar + '***' + lastChar;
}
const getList = () => {
    loading.value = true;
    inviteTopList({}).then(res => {
        list.value = res.data
        let arr = []
        res.data.forEach(item => {
            item.nickName = maskNicknameAdvanced(item.nickName)
            item.scrollText = item.nickName + '邀请好友已获得' + item.amount + '元'
            arr.push(item)
        });
        listRandom.value = randomSortArray(arr)
        listData.value = list.value
        pageShow.value = true
        finished.value = true
        loading.value = false;
    })
}
const showActivity = ref(false)
const activityFn = () => {
    getInfo2025({}).then(res => {
        if (res.data.state == 1) {
            showActivity.value = true
            getList()
        } else {
            pageShow.value = true
        }
    }).finally(() => {
        pageShow.value = true
    })
}
const info = ref({})
const getInfo = async () => {
    briefInfo().then(async res => {
        info.value = res.data
        
        info.value.inviteQrcode1 = await setImage(res.data.inviteQrcode)
        info.value.photo1 = await setImage(res.data.photo)
    })
}
const setImage = async (url) => {
    return new Promise((resolve) => {
        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.onload = function () {
            let canvas = document.createElement('canvas')
            canvas.width = img.width;
            canvas.height = img.height;
            let context = canvas.getContext("2d");
            context.drawImage(img, 0, 0, img.width, img.height);
            // 将canvas的内容转换为base64编码的字符串
            let base64 = canvas.toDataURL("image/png");// 可以根据需要更改为其他格式，如'image/jpeg'等
            resolve(base64)

        };
        img.onerror = function (err) {
            alert('图片加载失败' + JSON.stringify(err))
        };
        img.src = url + '?time=' + new Date().getTime()
    })
}
</script>

<style lang="less" scoped>
body {
    background: #fff;
}

.page-locked {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

// 隐藏元素的样式
.bg-hidden {
    z-index: -1;
    position: fixed !important;
    top: 0;
    left: 100vw;
}

// 默认遮罩样式
.mask-default {
    top: 10.8125rem;
    transform: translateX(-50%);
    width: 19.5rem;
    height: 21.5625rem;
}

// 通知轮播样式
.notice-swipe {
    height: 2.5rem;
    line-height: 2.5rem;
    color: #000;
    z-index: 99;
    position: absolute;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 16.25rem;

    background: #FFFFFF;
    box-shadow: 0 0.125rem 0.625rem 0 #5ea8ff36;
    border-radius: 1.25rem;

    .item-volume {
        height: 2.5rem;
        font-weight: 400;
        font-size: 0.9375rem;
        color: #FF6731;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 1.25rem;
            height: 1.25rem;
            margin-right: 0.5rem;
        }
    }
}

// 背景样式
.bg {
    width: 100%;
    height: 45.5rem;
    min-height: 100vh;
    position: relative;
    overflow: auto;
    background-image: linear-gradient(180deg, #8866ED 0%, #9071ED 87%);
    align-items: flex-start;

    .bgImg {
        position: absolute;
        width: 100vw;
        height: 50.75rem;
        top: -5.25rem;
        left: 0;
        object-fit: cover;
    }

    .modal {
        position: relative;
        z-index: 1;
        width: 19.5rem;
        height: 21.5625rem;
        margin: 10.8125rem auto 0;
        top: 0;
        border: 0;
        border-radius: 0;
        background: url('../../../assets/register/registerCodeContent.png') center / 19.5rem 21.5625rem no-repeat;
        .code {
            width: 12.25rem;
            height: 12.25rem;
            border-radius: 1rem;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .codeImg {
            width: 2.75rem;
            height: 2.75rem;
            border-radius: 50%;
            
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }

}

// 活动背景样式
.bg_1 {
    width: 100%;
    min-height: 100vh;
    position: relative;
    background: #216DE6;
    overflow: auto;
    
    .lineNo {
        height: 19.375rem;
    }
    
    .bgImg {
        position: absolute;
        width: 100vw;
        height: 41.5625rem;
        top: 0;
    }

    
}

// 遮罩样式
.mask_1 {
    position: absolute;
    width: 18.75rem;
    height: 18.75rem;
    overflow: auto;
    z-index: 2;
    top: 12.25rem;
    left: 50%;
    transform: translateX(-50%);
}

// 卡片列表样式
.card_list {
    position: relative;
    margin: 7.4375rem 1rem 0;
    background: #fff;
    border-radius: 1.25rem;
    padding: 1rem;
    z-index: 3;
    
    // 卡片标题样式
    .card_title {
        display: flex;
        justify-content: space-around;
        font-weight: 600;
        font-size: 1rem;
        color: #FFA076;

        // 标题项样式
        .title-item {
            position: relative;
            padding-bottom: 0.5rem;

            // 下划线样式
            .line {
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 80%;
                background: #fff;
                border-radius: 0.125rem;
                height: 0.25rem;
            }
        }

        // 激活状态样式
        .active {
            font-weight: 700;
            color: #FF7537;

            .line {
                background: #FF7537;
            }
        }
    }

    // 滚动内容样式
    .scroll_content {
        min-height: 22.5rem;
        overflow-y: auto;

        .realIcon {
            margin-top: 0.625rem;
            width: 5.25rem;
            height: 7.875rem;
        }
    }

    // 排行榜项样式
    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1rem;
        font-weight: 600;
        font-size: 1rem;
        color: #1D1D2C;

        .item_l {
            display: flex;
            align-items: center;

            .avatar {
                width: 2.5rem;
                height: 2.5rem;
                margin-right: 0.5rem;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
        }

        .ranking {
            width: 2.25rem;
            height: 1.375rem;
            text-align: center;
            margin-right: 0.75rem;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .item_r {
            font-size: 1rem;
            color: #FF7537;
        }
    }

    // 收益记录项样式
    .item1 {
        height: 3.125rem;
    }
}

// 引导模态框样式
.modal-content {
    background-color: rgba(0, 0, 0, .6);
    top: 0;
    left: 0;
    text-align: right;
    z-index: 999;
    width: 100vw;
    height: 100%;
    min-height: 100vh;
    position: fixed;

    img {
        position: relative;
        display: block;
    }

    .img1 {
        height: 8.5rem;
        margin-top: 0.5rem;
        display: inline-block;
        right: 4%;
    }

    .img2 {
        width: 76.8%;
        left: 50%;
        transform: translateX(-50%);
    }

    .img3 {
        height: 4.875rem;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
